import React, { useState } from 'react';

import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import defaultClasses from '../../../../components/BobTableContextMenu.module.css';

const ClientContextMenu = ({
    dataItem,
    history,
    setCoreClient,
    setDeleteClientModalOpen,
    setSelectedClient,
    ...props
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleEditClient = client => {
        const path = '/v2/dashboard/core/entities/manage';

        const queryValues = queryString.parse(history.location.search);
        queryValues.entityType = 'client';
        queryValues.entityId = client.id;

        const queryValuesString = queryString.stringify(queryValues);
        history.push(`${path}?${queryValuesString}`);
        setCoreClient(client);
    };

    const handleDeleteClient = client => {
        setSelectedClient(client);
        setDeleteClientModalOpen(true);
    };

    return (
        <React.Fragment>
            <Button
                aria-owns={open && 'render-props-menu'}
                aria-haspopup="true"
                onClick={handleOpen}
                className={defaultClasses.toggleButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            // eslint-disable-next-line react/jsx-closing-bracket-location
            >
                <MenuItem
                    onClick={() => handleEditClient(dataItem)}
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                >
                    <span className="material-icons-outlined md-18">
                        edit
                    </span>
                    Edit
                </MenuItem>
                <MenuItem
                    onClick={() => handleDeleteClient(dataItem)}
                    classes={{
                        root: defaultClasses.menuItem
                    }}
                >
                    <span className="material-icons-outlined md-18">
                        do_not_disturb_on
                    </span>
                    Deactivate
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
};

export default withRouter(ClientContextMenu);
